import React from 'react';
import { Link } from 'react-router-dom';
import ScannerHeading from './ScannerHeading';
import ImageUploadField from './ImageUploadField';
import ScannerDetailsPanel from './ScannerDetailsPanel';
import RateLimitModal from './components/RateLimitModal';
import InsufficientCreditsModal from './components/InsufficientCreditsModal';
import useScannerWorkflow from './hooks/useScannerWorkflow';

export default function ScannerPage() {
  const {
    uploadRef,
    imagePreview,
    isScanning,
    scanError,
    shouldShowGlobalError,
    hasExtractedData,
    showRateLimitModal,
    setShowRateLimitModal,
    rateLimitMessage,
    showInsufficientCreditsModal,
    setShowInsufficientCreditsModal,
    creditBalance,
    primaryFields,
    additionalFields,
    primaryFieldValues,
    handleImageUpload,
    handleRemoveImage,
    handlePrimaryFieldChange,
    handleAdditionalFieldLabelChange,
    handleAdditionalFieldValueChange,
    handleAddAdditionalField,
    handleRemoveAdditionalField,
    handleConfirm,
    handleCancel,
    handleRetryScan,
    handleDismissScanError
  } = useScannerWorkflow();

  return (
    <div className="flex-1 flex flex-col items-center px-4 py-12">
      {showRateLimitModal && (
        <RateLimitModal
          message={rateLimitMessage}
          onClose={() => setShowRateLimitModal(false)}
        />
      )}
      {showInsufficientCreditsModal && (
        <InsufficientCreditsModal
          balance={creditBalance}
          onClose={() => setShowInsufficientCreditsModal(false)}
        />
      )}
      <div className="w-full max-w-5xl space-y-8">
        <ScannerHeading />
        {shouldShowGlobalError && (
          <div className="bg-amber-400/90 text-gray-900 border border-amber-200 rounded-2xl px-4 py-3 text-sm shadow-lg">
            {scanError}
          </div>
        )}
        {imagePreview ? (
          <ScannerDetailsPanel
            imageSrc={imagePreview}
            primaryFields={primaryFields}
            additionalFields={additionalFields}
            primaryFieldValues={primaryFieldValues}
            onPrimaryFieldChange={handlePrimaryFieldChange}
            onAdditionalFieldLabelChange={handleAdditionalFieldLabelChange}
            onAdditionalFieldChange={handleAdditionalFieldValueChange}
            onAddAdditionalField={handleAddAdditionalField}
            onRemoveAdditionalField={handleRemoveAdditionalField}
            onConfirm={handleConfirm}
            onCancel={handleCancel}
            isScanning={isScanning}
            scanError={scanError}
            onRetryScan={handleRetryScan}
            onDismissScanError={handleDismissScanError}
            hasExtractedData={hasExtractedData}
          />
        ) : (
          <>
            <div ref={uploadRef}>
              <ImageUploadField
                imagePreview={imagePreview}
                onImageUpload={handleImageUpload}
                onImageRemove={handleRemoveImage}
              />
            </div>
            <div className="relative flex items-center py-4">
              <div className="flex-grow border-t border-white/20"></div>
              <span className="px-4 text-sm font-semibold text-gray-300 uppercase tracking-wider">OR</span>
              <div className="flex-grow border-t border-white/20"></div>
            </div>
            <div className="flex justify-center">
              <Link
                to="/contacts"
                className="inline-flex items-center gap-2 px-6 py-3 rounded-2xl font-semibold text-white bg-gradient-to-r from-blue-600 to-purple-600 hover:from-blue-500 hover:to-purple-500 shadow-lg transition-all hover:-translate-y-0.5"
              >
                <svg className="w-5 h-5" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <path strokeLinecap="round" strokeLinejoin="round" d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z" />
                </svg>
                <span>See all Contacts</span>
              </Link>
            </div>
          </>
        )}
      </div>
    </div>
  );
}
